import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "google",
  "use": "google-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"google\"><path d=\"M310 13H182c-16 0-35 0-54 3-19 6-38 16-58 32-25 26-38 54-38 83s10 51 29 71c19 22 45 32 77 32h19c0 3-3 6-3 9v13c0 10 3 16 6 26 3 6 6 12 10 19-16 0-36 3-58 6s-45 13-64 23c-19 9-32 22-38 38-7 16-10 29-10 42 0 25 10 44 32 64 22 19 54 28 99 28 55 0 96-12 122-38 29-26 41-51 41-83 0-23-6-39-16-55-6-12-19-25-32-38l-19-16-13-13c-3-3-3-9-3-16 0-6 3-13 7-19 0-3 6-6 9-13 7-6 13-13 19-16 4-6 10-13 13-19 10-13 16-32 16-54 0-13 0-23-3-32-3-10-10-20-13-26s-9-13-13-19c-6-3-9-7-16-10h39zm-70 349c13 12 16 25 16 41 0 19-6 35-22 48s-39 19-71 19c-35 0-61-6-80-22s-32-32-32-54c0-13 3-23 7-29 6-7 12-13 19-19 6-7 13-10 19-13s10-3 13-7c13-3 29-6 41-9 13 0 23-3 26 0h13c22 19 41 32 51 45zm-19-189c0 9-7 16-10 25-13 10-25 16-45 20-12 0-25-4-35-13-9-10-19-19-25-32-13-23-20-48-20-71 0-16 4-32 13-48 13-12 26-22 45-22 13 0 26 3 35 13 10 6 19 19 23 29 12 25 19 51 19 76v23zm288 38h-67v-67h-39v67h-67v39h67v67h39v-67h70z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/google.svg
// module id = 194
// module chunks = 0